module.exports = __webpack_public_path__ + "static/media/pixl-logo-black.613e6b29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pixl-logo-black.png
// module id = 2862
// module chunks = 0